import HeaderTags from 'app/shared-components/helmet/HeaderTags';
import _ from '@lodash';
import Typography from '@mui/material/Typography';
import { motion } from 'framer-motion';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardActionArea from '@mui/material/CardActionArea';
import Grid from '@mui/material/Grid';
import states from 'app/shared-components/controls/states.json';
import NavLinkAdapter from '@fuse/core/NavLinkAdapter';
import { Link } from 'react-router-dom';
import Button from '@mui/material/Button';
import FuseSvgIcon from '@fuse/core/FuseSvgIcon';


const container = {
    show: {
      transition: {
        staggerChildren: 0.05,
      },
    },
  };

  const item = {
    hidden: { opacity: 0, y: 40 },
    show: { opacity: 1, y: 0 },
  };

export default function ProviderStates() {

  const host = window.location.protocol + '//' + window.location.host;
  const orgImage=  host + '/assets/images/logo/HALESPRING-HEADER-191.jpg';
  const basePath= '/public/search/providers/state/';

  return (
    <>
      <HeaderTags title="Mental Health Provider By State" 
                  description="Find mental health provider profiles by state of practice." 
                  keywords="Mental Health,Directory,Search,Therapist,Therapy,Referrals,Pyschologist,Psychiatrist"
                  image={orgImage}
      />
      
    <div className="pt-48">
      {/* Hero */}
      <section className="mb-48">
        <div className="container">
          
          <h1 className="h3 lg:h1 text-center">
            Mental Health Provider By State
          </h1>
          
          <div className="flex flex-col items-center">
            <div className="mt-12">
              <Button
                component={Link}
                to={'/public/search'}
                color="secondary"
                endIcon={<FuseSvgIcon>heroicons-outline:search</FuseSvgIcon>}
              >
                Advanced Search
              </Button>
            </div>
          </div>
        </div>
      </section>
      
      {/* States */}
      <section className="bg-white">
        <div className="container bg-white pt-40 pb-40">
          <Grid container spacing={2} alignItems="stretch" className="w-full m-0 p-0">
              {states.map((state) => 
				        <Grid key={state.value} item xs={12} sm={6} md={4} lg={3}>
               		 <Card component={motion.div} variants={item} >
                     <CardActionArea component={NavLinkAdapter} to={basePath + state.value}>
                          <CardContent>
                             <Typography color="secondary">
                               {state.name}
                             </Typography>
                          </CardContent>
        		         </CardActionArea>
            		   </Card>
                </Grid>
              )}
          </Grid>

        </div>
      </section>

    </div>
    </>
  );
}